<template>
  <header class="font-redhat">
    <nav
      class="flex items-center justify-between p-4 lg:px-8 bg-[#FFF]"
      aria-label="Global"
    >
      <div class="flex lg:flex-1">
        <a href="/" class="-m-1.5 p-1.5">
          <span class="sr-only">Ductclean FM limited</span>
          <img class="h-8 w-auto" src="../../assets/logo.png" alt="" />
        </a>
        <img
          src="../../assets/celebrating_header.svg"
          width="144px"
          class="ml-[70px] sm:ml-10"
          alt="Celebrating 40 years "
        />
      </div>
      <div class="flex lg:hidden">
        <button
          v-if="showSub"
          type="button"
          class="mr-2.5 inline-flex items-center justify-center rounded-md text-gray-700"
          @click="changeSubMenu"
        >
          <span class="sr-only">Open sub menu</span>
          <ChevronDownIcon class="h-5 w-5 mr-6"></ChevronDownIcon>
        </button>
        <button
          type="button"
          class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          @click="mobileMenuOpen = true"
        >
          <span class="sr-only">Open main menu</span>
          <Bars3Icon class="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      <div class="hidden lg:flex lg:gap-x-12">
        <a
          :href="item.href"
          v-for="item in navigation"
          :key="item.name"
          :class="item.name === 'Careers' ? 'relative' : ''"
        >
          <a
            :href="item.href"
            class="text-sm font-semibold leading-6 text-gray-900"
          >
            {{ item.name }}
          </a>
          <span
            v-if="item.name === 'Careers' && careersData.length > 0"
            class="bg-gradient-to-r from-ocean to-teal text-white ml-2 rounded-full py-0.5 px-1.5 text-xs font-bold md:inline-block absolute -top-2 -right-6"
          >
            {{ careersData.length }}
          </span>
        </a>
      </div>
      <div class="hidden lg:flex lg:flex-1 lg:justify-end">
        <button
          onclick="location.href='/contact'"
          type="button"
          class="rounded-full bg-gradient-to-r from-ocean to-teal px-4 py-2.5 text-sm font-bold text-white shadow-sm hover:from-oceanlight hover:to-teallight focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Contact Us
        </button>
      </div>
    </nav>
    <Dialog
      as="div"
      class="lg:hidden"
      @close="mobileMenuOpen = false"
      :open="mobileMenuOpen"
    >
      <div class="fixed inset-0 z-10" />
      <DialogPanel
        class="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-[#FFF] px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
      >
        <div class="flex items-center justify-between">
          <a href="/" class="-m-1.5 p-1.5 outline-none">
            <span class="sr-only">Ductclean FM Limited</span>
            <img class="h-8 w-auto" src="../../assets/logo.png" alt="" />
          </a>
          <button
            type="button"
            class="-m-2.5 rounded-md p-2.5 text-gray-700"
            @click="mobileMenuOpen = false"
          >
            <span class="sr-only">Close menu</span>
            <XMarkIcon class="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div class="mt-6 flow-root">
          <div class="-my-6 divide-y divide-gray-500/10">
            <div class="space-y-2 py-6">
              <a
                v-for="item in navigation"
                :key="item.name"
                :href="item.href"
                class="-mx-3 rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50 flex items-center"
                >{{ item.name }}
                <span
                  v-if="item.name === 'Careers' && careersData.length > 0"
                  class="bg-gradient-to-r from-ocean to-teal text-white ml-2 rounded-full py-0.5 px-1.5 text-xs font-bold md:inline-block"
                >
                  {{ careersData.length }}
                </span>
              </a>
            </div>
            <div class="py-6">
              <button
                onclick="location.href='/contact'"
                type="button"
                class="rounded-full bg-gradient-to-r from-ocean to-teal px-4 py-2.5 text-sm font-bold text-white shadow-sm hover:from-oceanlight hover:to-teallight focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  </header>
</template>
<script>
import { Dialog, DialogPanel } from "@headlessui/vue";
import {
  Bars3Icon,
  XMarkIcon,
  ChevronDownIcon,
} from "@heroicons/vue/24/outline";

export default {
  components: {
    Dialog,
    DialogPanel,
    Bars3Icon,
    XMarkIcon,
    ChevronDownIcon,
  },
  props: {
    subNavigation: {
      type: Array,
      default: () => [],
    },
    showSub: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      navigation: [
        { name: "Our Company", href: "/our-company" },
        { name: "Sectors & Services", href: "/services" },
        { name: "Technology", href: "/technology" },
        { name: "Careers", href: "/careers" },
        { name: "Blog", href: "/blog" },
      ],
      mobileMenuOpen: false,
      careersData: [],
    };
  },
  methods: {
    changeSubMenu() {
      this.$emit("showSub");
    },
    getCareers() {
      this.axios
        .get("https://stingray-app-qsr9b.ondigitalocean.app/get_jobs")
        .then((response) => {
          this.careersData = response.data;
        });
    },
  },
  computed: {},
  created() {
    this.getCareers();
  },
  mounted() {},
};
</script>
